enum ForgotPasswordStatus {
    PENDING = 'statusPending',
    SUCCESS = 'statusSuccess',
    FAILED = 'statusFailed',
    USER_NOT_FOUND = 'statusUserNotFound'
}

export default ForgotPasswordStatus
